var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 77,
    viewBox: "0 0 190 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.87375 1V46.4091H22.4397L37 21.1818H74V1H5.87375Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87375 1V46.4091H22.4397L37 21.1818H74V1H5.87375Z",
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8307 46.2409L6.08819 17.5239L5.84433 17.9443L22.4691 46.4511L22.8307 46.2409Z",
    fill: "#3E2723",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 75H35.2215L51.5687 58.6527V46.4091H22.4313L0 7.92909V75Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 75H35.2215L51.5687 58.6527V46.4091H22.4313L0 7.92909V75Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2114 46.9557L50.8624 46.7539L34.7169 74.9874H35.2004L51.2198 46.9683L51.2114 46.9557Z",
    fill: "#263238",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 21.1818L51.5687 46.4091L35.2215 75H74V21.1818H37Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 21.1818L51.5687 46.4091L35.2215 75H74V21.1818H37Z",
    fill: "url(#paint2_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 21.1818L51.5687 46.4091L35.2215 75H74V21.1818H37Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 21.1818L51.5687 46.4091L35.2215 75H74V21.1818H37Z",
    fill: "url(#paint3_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87375 1V46.4091H22.4397L37 21.1818H74V1H5.87375Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87375 1V46.4091H22.4397L37 21.1818H74V1H5.87375Z",
    fill: "url(#paint4_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 21.1818V29.9903L69.9636 21.1818H37Z",
    fill: "url(#paint5_radial_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 75H35.2215L51.5687 58.6527V46.4091H22.4313L0 7.92909V75Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 75H35.2215L51.5687 58.6527V46.4091H22.4313L0 7.92909V75Z",
    fill: "url(#paint6_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87375 18.0074L29.9448 42.0742L22.4355 46.4091L5.87375 18.0074Z",
    fill: "url(#paint7_radial_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2467 74.958L44.0594 42.0784L51.5687 46.4091L35.2467 74.958Z",
    fill: "url(#paint8_radial_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 54.8182C46.2884 54.8182 53.8182 47.2884 53.8182 38C53.8182 28.7116 46.2884 21.1818 37 21.1818C27.7116 21.1818 20.1818 28.7116 20.1818 38C20.1818 47.2884 27.7116 54.8182 37 54.8182Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 51.4545C44.4307 51.4545 50.4545 45.4307 50.4545 38C50.4545 30.5693 44.4307 24.5455 37 24.5455C29.5692 24.5455 23.5454 30.5693 23.5454 38C23.5454 45.4307 29.5692 51.4545 37 51.4545Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 20.7614C27.708 20.7614 20.1818 28.2875 20.1818 37.5795V38C20.1818 28.708 27.708 21.1818 37 21.1818H74V20.7614H37Z",
    fill: "#3E2723",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5477 46.4091C48.6382 51.4293 43.2227 54.8182 37 54.8182C30.7773 54.8182 25.3534 51.4293 22.4523 46.4091H22.4355L0 7.92909V8.34955L22.4523 46.8296C25.3618 51.8498 30.7773 55.2386 37 55.2386C43.2227 55.2386 48.6382 51.854 51.5477 46.8296H51.5687V46.4091H51.5435H51.5477Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.4204 21.1818C37.349 21.1818 37.2817 21.1902 37.2102 21.1944C46.4013 21.308 53.8182 28.7836 53.8182 38C53.8182 47.2164 46.4013 54.692 37.2102 54.8056C37.2817 54.8056 37.349 54.8182 37.4204 54.8182C46.7125 54.8182 54.2386 47.292 54.2386 38C54.2386 28.708 46.7125 21.1818 37.4204 21.1818Z",
    fill: "#3E2723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7159 46.9557C53.1455 44.4834 53.9737 41.6243 53.9737 38.5634C53.9747 36.8386 53.7095 35.124 53.1875 33.4801C53.5869 34.9181 53.8182 36.4233 53.8182 37.9916C53.8182 41.0525 52.9899 43.9116 51.5603 46.3839L51.5687 46.4007L35.2215 74.9916H35.7092L51.7159 46.9557Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 1.42045C57.3626 1.42045 73.8823 17.8728 74 38.2102C74 38.1387 74.0042 38.0715 74.0042 38C74.0042 17.5659 57.4383 1 37.0042 1C16.5701 1 0 17.5659 0 38C0 38.0715 0.00420464 38.1387 0.00420464 38.2102C0.117727 17.8728 16.6374 1.42045 37 1.42045Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 74.5795C57.3626 74.5795 73.8823 58.1272 74 37.7898C74 37.8612 74.0042 37.9285 74.0042 38C74.0042 58.4341 57.4383 75 37.0042 75C16.5701 75 0 58.4341 0 38C0 37.9285 0.00420464 37.8612 0.00420464 37.7898C0.117727 58.1272 16.6374 74.5795 37.0042 74.5795H37Z",
    fill: "#3E2723",
    fillOpacity: 0.15
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.601 38.212V72.2187L140.42 72.1611C158.182 72.1035 158.221 72.1035 160.314 71.6618C174.043 68.7623 181.839 59.987 183.759 45.3359C184.604 38.8072 184.163 31.1456 182.626 25.5002C179.689 14.7471 172.392 7.7576 161.485 5.22294C157.433 4.28204 156.339 4.22444 138.904 4.22444H122.601V38.212ZM146.872 24.1177C149.657 26.8252 151.98 29.0526 152.038 29.0718C152.095 29.0718 154.534 26.8636 157.453 24.1369L162.733 19.202H166.766H170.798V38.212V57.2219H165.517H160.237L160.199 46.7569L160.141 36.2726L156.224 40.5546C154.054 42.9165 152.191 44.8367 152.076 44.8367C151.961 44.8367 150.213 42.9933 148.216 40.7274L144.587 36.6374L144.53 46.9297L144.491 57.2219L139.249 57.1835L134.026 57.1259L133.969 38.404C133.949 28.1117 133.969 19.5668 134.026 19.4324C134.084 19.2596 135.063 19.202 137.963 19.202H141.822L146.872 24.1177Z",
    fill: "#007AC3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5909 48.0114V29.2614H99.7727V48.0114H96.5909ZM88.8068 40.2273V37.0455H107.557V40.2273H88.8068Z",
    fill: "#DB4437"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 8.9725,
    y1: 29.1789,
    x2: 31.0464,
    y2: 16.2835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 43.2648,
    y1: 66.8011,
    x2: 18.727,
    y2: 52.4216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 47.8898,
    y1: 18.575,
    x2: 54.0704,
    y2: 45.6102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 47.8898,
    y1: 18.575,
    x2: 54.0704,
    y2: 45.6102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 8.9725,
    y1: 29.1789,
    x2: 31.0464,
    y2: 16.2835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4023 21.1608) scale(35.3518)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 43.2648,
    y1: 66.8011,
    x2: 18.727,
    y2: 52.4216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.84432 18.0368) scale(32.8123)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9159 38.0589) scale(36.9453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 74,
    height: 74,
    rx: 37,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugin);
export default __webpack_public_path__ + "static/media/plugin.a6820febe640da5d72740701ca591c1b.svg";
export { ForwardRef as ReactComponent };